module.exports = __webpack_public_path__ + "static/media/mongoose.b24f0f3d.png";